<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-12">
        <commentaire :title="'editCommandeTlpe.infoCommentaire.commentaireInterne'"
                     v-model="commandeTlpe.commentaireInterne"
                     :commentaires="commentaires">
        </commentaire>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import commentaire from '@/components/general/commentaire';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    commandeTlpe: {
      type: Object,
      required: true,
    },
  },
  components: {
    commentaire,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    commentaires() {
      return this.parametre(PARAMETRES_KEYS.commentaire);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.commentaire,
      ]);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw (e);
    }
  },
};

</script>
